<app-star-button
  class="max-xl:!hidden"
  [showLoading]="emailsPageStateService.isLoadingStarred()"
  (click)="actions.addEmailToStar()" />

@for (button of emailsService.commonActionButtons; track button) {
  @switch (button) {
    @case (EmailActionsEnum.Validate) {
      <app-validate-button
        [disabled]="emailsPageStateService.isLoadingValidate()"
        [showButton]="
          emailsService.validateIsAvailable &&
          !emailsPageStateService.isLoadingValidate()
        "
        [showLoading]="emailsPageStateService.isLoadingValidate()"
        (click)="actions.setValidated()" />
    }

    @case (EmailActionsEnum.Reply) {
      <app-reply-button
        class="max-xl:!hidden"
        [showButton]="
          emailsService.oneSelected &&
          !(
            !!emailsPageStateService.replyingEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          )
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          !!emailsPageStateService.replyingEmailId() &&
          emailsPageStateService.loadingActionFromHeader() &&
          emailsService.oneSelected
        "
        (click)="buttonActionsService.reply()" />
    }

    @case (EmailActionsEnum.ReplyAll) {
      <app-reply-all-button
        class="max-xl:!hidden"
        [showButton]="
          emailsService.oneSelected &&
          !(
            !!emailsPageStateService.replyingAllEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          )
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          !!emailsPageStateService.replyingAllEmailId() &&
          emailsPageStateService.loadingActionFromHeader() &&
          emailsService.oneSelected
        "
        (click)="buttonActionsService.replyAll()" />
    }

    @case (EmailActionsEnum.Forward) {
      @if (emailsService.oneSelected) {
        <app-forward-button
          class="max-xl:!hidden"
          [showButton]="
            !(
              !!emailsPageStateService.forwardingAsTextEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          "
          [disabled]="emailsPageStateService.isAnyActionInProgress()"
          [showLoading]="
            !!emailsPageStateService.forwardingAsTextEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          "
          (click)="buttonActionsService.forward()" />
        <app-forward-attachment-button
          class="max-xl:!hidden"
          [showButton]="
            !(
              !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          "
          [disabled]="emailsPageStateService.isAnyActionInProgress()"
          [showLoading]="
            !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          "
          (click)="buttonActionsService.forwardAsAttachment()" />
      } @else {
        <app-forward-attachment-button
          class="max-xl:!hidden"
          [showButton]="
            !(
              !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          "
          [disabled]="emailsPageStateService.isAnyActionInProgress()"
          [showLoading]="
            !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
            emailsPageStateService.loadingActionFromHeader()
          "
          (click)="buttonActionsService.forwardAsAttachment()" />
      }
    }

    @case (EmailActionsEnum.Reassign) {
      @if (emailsPageStateService.multipleReassignIsAvailable()) {
        <app-reassign-button
          class="max-xl:!hidden"
          (click)="actionsModals.reassign()" />
      }
    }

    @case (EmailActionsEnum.Groups) {
      <app-groups-button
        class="max-xl:!hidden"
        (click)="actionsModals.openAddGroupDialog()" />
    }

    @case (EmailActionsEnum.Tags) {
      <app-tags-button
        class="max-xl:!hidden"
        (click)="actionsModals.openAddTagDialog()" />
    }
  }
}

<button mat-icon-button aria-label="Menu" [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <app-star-button
    [isMenu]="true"
    class="xl:!hidden"
    [showLoading]="emailsPageStateService.isLoadingStarred()"
    (click)="actions.addEmailToStar()" />

  @for (button of emailsService.commonActionButtons; track button) {
    @switch (button) {
      @case (EmailActionsEnum.Reply) {
        <app-reply-button
          class="xl:!hidden"
          [isMenu]="true"
          (click)="buttonActionsService.reply()"
          [showButton]="
            emailsService.oneSelected &&
            !(
              !!emailsPageStateService.replyingEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          " />
      }

      @case (EmailActionsEnum.ReplyAll) {
        <app-reply-all-button
          class="xl:!hidden"
          [isMenu]="true"
          (click)="buttonActionsService.replyAll()"
          [showButton]="
            emailsService.oneSelected &&
            !(
              !!emailsPageStateService.replyingAllEmailId() &&
              emailsPageStateService.loadingActionFromHeader()
            )
          " />
      }

      @case (EmailActionsEnum.Forward) {
        @if (emailsService.oneSelected) {
          <app-forward-button
            class="xl:!hidden"
            [isMenu]="true"
            (click)="buttonActionsService.forward()"
            [showButton]="
              !(
                !!emailsPageStateService.forwardingAsTextEmailId() &&
                emailsPageStateService.loadingActionFromHeader()
              )
            " />
          <app-forward-attachment-button
            class="xl:!hidden"
            [isMenu]="true"
            (click)="buttonActionsService.forwardAsAttachment()"
            [showButton]="
              !(
                !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
                emailsPageStateService.loadingActionFromHeader()
              )
            " />
        } @else {
          <app-forward-attachment-button
            class="xl:!hidden"
            [isMenu]="true"
            (click)="buttonActionsService.forwardAsAttachment()"
            [showButton]="
              !(
                !!emailsPageStateService.forwardingAsAttachmentEmailId() &&
                emailsPageStateService.loadingActionFromHeader()
              )
            " />
        }
      }

      @case (EmailActionsEnum.Reassign) {
        @if (emailsPageStateService.multipleReassignIsAvailable()) {
          <app-reassign-button
            class="xl:!hidden"
            [isMenu]="true"
            (click)="actionsModals.reassign()" />
        }
      }

      @case (EmailActionsEnum.Groups) {
        <app-groups-button
          class="xl:!hidden"
          [isMenu]="true"
          (click)="actionsModals.openAddGroupDialog()" />
      }

      @case (EmailActionsEnum.Tags) {
        <app-tags-button
          class="xl:!hidden"
          [isMenu]="true"
          (click)="actionsModals.openAddTagDialog()" />
      }

      @case (EmailActionsEnum.DeleteFinalMail) {
        <app-final-delete-button
          [isMenu]="true"
          (click)="actionsModals.finalDelete()" />
      }

      @case (EmailActionsEnum.SetRead) {
        <app-set-read-button [isMenu]="true" (click)="actions.setSeen(true)" />
      }

      @case (EmailActionsEnum.SetUnread) {
        <app-set-unread-button
          [isMenu]="true"
          (click)="actions.setSeen(false)" />
      }

      @case (EmailActionsEnum.MarkAsSpam) {
        <app-mark-as-span-button [isMenu]="true" (click)="actions.setSpam()" />
      }

      @case (EmailActionsEnum.Delete) {
        <app-delete-button [isMenu]="true" (click)="actionsModals.delete()" />
      }

      @case (EmailActionsEnum.DownloadSingleEml) {
        <app-download-single-eml-button
          [showButton]="true"
          [isMenu]="true"
          (click)="actions.downloadSingleEML()" />
      }

      @case (EmailActionsEnum.DownloadEml) {
        <app-download-eml-button
          [showButton]="true"
          [isMenu]="true"
          (click)="actions.downloadEML()" />
      }

      @case (EmailActionsEnum.Restore) {
        <app-restore-button
          [isMenu]="true"
          (click)="actionsModals.restoreFromTrash()" />
      }

      @case (EmailActionsEnum.MarkAsNotSpam) {
        <app-mark-as-not-span-button
          [isMenu]="true"
          (click)="
            buttonActionsService.restoreMoveFolderChoose(
              emailsPageStateService.selection.selected,
              'restoreOneSpam'
            )
          " />
      }

      @case (EmailActionsEnum.MoveToFolder) {
        <app-move-to-folder-button
          [isMenu]="true"
          (click)="actionsModals.move()" />
      }

      @case (EmailActionsEnum.Archive) {
        <app-archive-button
          [isMenu]="true"
          (click)="actionsModals.setSelectedArchive()" />
      }

      @case (EmailActionsEnum.Audit) {
        @if (emailsService.oneSelected) {
          <app-audit-button
            [isMenu]="true"
            (click)="actionsModals.openAudit()" />
        }
      }

      @case (EmailActionsEnum.RetrySending) {
        @if (emailsService.isSelectedRetrySendingNeededState) {
          <app-retry-sending-button
            [isMenu]="true"
            (click)="actions.retrySend()" />
        }
      }

      @case (EmailActionsEnum.RestoreArchive) {
        <app-restore-archive-button
          [isMenu]="true"
          (click)="actionsModals.restoreFromArchive()" />
      }

      @case (EmailActionsEnum.Meta) {
        @if (emailsService.oneSelected) {
          <app-meta-button
            [isMenu]="true"
            (click)="
              actionsModals.openMeta(
                emailsPageStateService.selection.selected[0]
              )
            " />
        }
      }

      @case (EmailActionsEnum.Archiving) {
        <app-archiving-button
          [isMenu]="true"
          (click)="actionsModals.archiving()" />
      }
    }
  }
</mat-menu>
